export default __webpack_public_path__ + "images/0xdbfefd2e8460a6ee4955a68582f85708baea60a3.png";